'use client'

import AgentRreview from '@component/card/agent/review'
import SectionLayout from '@component/layout/section'
import SectionSwiper from '@component/layout/section/swiper'

export default function PromotedAgentContent({
  data
}) {

  return (
    <SectionLayout
      title='Get a free, no obligation appraisal from our top agents today'
      id='promoted-agent'
    >
      <SectionSwiper
        data={data}
        dataKey='id'
        Card={AgentRreview}
      ></SectionSwiper>
    </SectionLayout>
  )
}